import ProductsAPI from '../../api/products';

export const state = {
  products: [],
  categories: [],
  customFields: [],
  specificationPresets: [],
  sheetsWebhookUrl: '',
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getProducts: _state => _state.products,
  getCategories: _state => _state.categories,
  getCustomFields: _state => _state.customFields,
  getSpecificationPresets: _state => _state.specificationPresets,
  getSheetsWebhookUrl: _state => _state.sheetsWebhookUrl,
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  getProducts: async ({ commit }, params = {}) => {
    commit('SET_PRODUCTS_UI_FLAG', { isFetching: true });
    try {
      const response = await ProductsAPI.getProducts(params);
      commit('SET_PRODUCTS', response.data.payload || []);
    } finally {
      commit('SET_PRODUCTS_UI_FLAG', { isFetching: false });
    }
  },
  getProduct: async (_context, publicId) => {
    const response = await ProductsAPI.getProduct(publicId);
    return response.data.payload;
  },
  getCategories: async ({ commit }) => {
    const response = await ProductsAPI.getCategories();
    commit('SET_PRODUCT_CATEGORIES', response.data.payload || []);
  },
  getCustomFields: async ({ commit }) => {
    const response = await ProductsAPI.getCustomFields();
    commit('SET_PRODUCT_CUSTOM_FIELDS', response.data.payload || []);
  },
  getSpecificationPresets: async ({ commit }) => {
    const response = await ProductsAPI.getSpecificationPresets();
    commit('SET_PRODUCT_SPEC_PRESETS', response.data.payload || []);
  },
  createProduct: async ({ dispatch }, payload) => {
    const response = await ProductsAPI.createProduct(payload);
    await dispatch('getProducts');
    return response.data.payload;
  },
  updateProduct: async ({ dispatch }, { publicId, product }) => {
    const response = await ProductsAPI.updateProduct(publicId, product);
    await dispatch('getProducts');
    return response.data.payload;
  },
  deleteProduct: async ({ dispatch }, publicId) => {
    await ProductsAPI.deleteProduct(publicId);
    await dispatch('getProducts');
  },
  createCategory: async ({ dispatch }, category) => {
    const response = await ProductsAPI.createCategory(category);
    await dispatch('getCategories');
    return response.data.payload;
  },
  createCustomField: async ({ dispatch }, customField) => {
    const response = await ProductsAPI.createCustomField(customField);
    await dispatch('getCustomFields');
    return response.data.payload;
  },
  applySpecificationPreset: async ({ dispatch }, presetKey) => {
    const response = await ProductsAPI.applySpecificationPreset(presetKey);
    await dispatch('getCustomFields');
    return response.data.payload;
  },
  requestImageUpload: async (_context, { publicId, image, upload }) => {
    const response = await ProductsAPI.requestImageUpload(
      publicId,
      image,
      upload
    );
    return response.data.payload;
  },
  deleteImage: async (_context, { productPublicId, imagePublicId }) => {
    await ProductsAPI.deleteImage(productPublicId, imagePublicId);
  },
  getSettings: async ({ commit }) => {
    const response = await ProductsAPI.getSettings();
    commit('SET_SHEETS_WEBHOOK_URL', response.data.sheets_webhook_url || '');
    return response.data;
  },
  updateSettings: async ({ commit }, { sheetsWebhookUrl }) => {
    const response = await ProductsAPI.updateSettings({
      sheets_webhook_url: sheetsWebhookUrl,
    });
    commit('SET_SHEETS_WEBHOOK_URL', response.data.sheets_webhook_url || '');
  },
};

export const mutations = {
  SET_PRODUCTS_UI_FLAG(_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  SET_PRODUCTS(_state, data) {
    _state.products = data;
  },
  SET_PRODUCT_CATEGORIES(_state, data) {
    _state.categories = data;
  },
  SET_PRODUCT_CUSTOM_FIELDS(_state, data) {
    _state.customFields = data;
  },
  SET_PRODUCT_SPEC_PRESETS(_state, data) {
    _state.specificationPresets = data;
  },
  SET_SHEETS_WEBHOOK_URL(_state, url) {
    _state.sheetsWebhookUrl = url;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
